export const ZITADEL_LANGUAGES = [
  { code: 'de', key: 'de-DE', name: 'German' },
  { code: 'en', key: 'en-US', name: 'English' },
  { code: 'es', key: 'es-MX', name: 'Español' },
  { code: 'fr', key: 'fr-FR', name: 'French' },
  { code: 'it', key: 'it-IT', name: 'Italian' },
  { code: 'ko', key: 'ko-KO', name: '한국어' },
  { code: 'pt', key: 'pt-PT', name: 'Portuguese' }
];
